import { useState } from "react";

export default ({ data }) => {
    let {
      html,
      paddingTop,
      paddingBottom,
      paddingRight,
      paddingLeft,
    } = data;

    const [height, setHeight] = useState(100);
  
    return (
      <div style={{position: "relative"}}>
        {!!html ? (
          <iframe style={{ border:0, width: "100%", height, paddingTop, paddingBottom, paddingRight, paddingLeft}}
            srcDoc={html}
            onLoad={(e) => {
              console.log(e);
              setHeight(e.target.contentWindow.document.body.scrollHeight + 50);
            }}
          ></iframe>
        ) : (
          <div>Template</div>
        )}
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, zIndex: Math.max }}/>
      </div>
    );
  };
  